import { v4 as uuidv4 } from 'uuid'

export const CONDITIONS = {
  EVERY: 'every',
  EVERY_STREAK_OF: 'everyStreakOf',
  FIRST_STREAK_OF: 'firstStreakOf',
  STREAK_GREATER_THAN: 'streakGreaterThan',
  STREAK_LOWER_THAN: 'streakLowerThan',
  BET: 'bet',
  WIN: 'win',
  LOSE: 'lose',
  INCREASE_BY_PERCENTAGE: 'increaseByPercentage',
  DECREASE_BY_PERCENTAGE: 'decreaseByPercentage',
  INCREASE_WIN_CHANCE_BY: 'increaseWinChanceBy',
  DECREASE_WIN_CHANCE_BY: 'decreaseWinChanceBy',
  ADD_TO_AMOUNT: 'addToAmount',
  SUBTRACT_FROM_AMOUNT: 'subtractFromAmount',
  ADD_TO_WIN_CHANCE: 'addToWinChance',
  SUBTRACT_FROM_WIN_CHANCE: 'subtractFromWinChance',
  SET_AMOUNT: 'setAmount',
  SET_WIN_CHANCE: 'setWinChance',
  SWITCH_OVER_UNDER: 'switchOverUnder',
  RESET_AMOUNT: 'resetAmount',
  RESET_WIN_CHANCE: 'resetWinChance',
  STOP: 'stop',
  LOSS: 'loss',
  BALANCE: 'balance',
  PROFIT: 'profit',
  GREATER_THAN: 'greaterThan',
  GREATER_THAN_OR_EQUAL_TO: 'greaterThanOrEqualTo',
  LOWER_THAN: 'lowerThan',
  LOWER_THAN_OR_EQUAL_TO: 'lowerThanOrEqualTo'
}

export const LABELS = {
  every: 'betConditionLabels.every',
  everyStreakOf: 'betConditionLabels.everyStreakOf',
  firstStreakOf: 'betConditionLabels.firstStreakOf',
  streakGreaterThan: 'betConditionLabels.streakGreaterThan',
  streakLowerThan: 'betConditionLabels.streakLowerThan',
  bet: 'betConditionLabels.bet',
  win: 'betConditionLabels.win',
  lose: 'betConditionLabels.lose',
  increaseByPercentage: 'betConditionLabels.increaseByPercentage',
  decreaseByPercentage: 'betConditionLabels.decreaseByPercentage',
  increaseWinChanceBy: 'betConditionLabels.increaseWinChanceBy',
  decreaseWinChanceBy: 'betConditionLabels.decreaseWinChanceBy',
  addToAmount: 'betConditionLabels.addToAmount',
  subtractFromAmount: 'betConditionLabels.subtractFromAmount',
  addToWinChance: 'betConditionLabels.addToWinChance',
  subtractFromWinChance: 'betConditionLabels.subtractFromWinChance',
  setAmount: 'betConditionLabels.setAmount',
  setWinChance: 'betConditionLabels.setWinChance',
  switchOverUnder: 'betConditionLabels.switchOverUnder',
  resetAmount: 'betConditionLabels.resetAmount',
  resetWinChance: 'betConditionLabels.resetWinChance',
  stop: 'betConditionLabels.stop',
  loss: 'betConditionLabels.loss',
  balance: 'betConditionLabels.balance',
  profit: 'betConditionLabels.profit',
  greaterThan: 'betConditionLabels.greaterThan',
  greaterThanOrEqualTo: 'betConditionLabels.greaterThanOrEqualTo',
  lowerThan: 'betConditionLabels.lowerThan',
  lowerThanOrEqualTo: 'betConditionLabels.lowerThanOrEqualTo'
}

export const profitConditionsOptions = {
  onType: [
    { label: LABELS.balance, id: uuidv4(), value: CONDITIONS.BALANCE },
    { label: LABELS.profit, id: uuidv4(), value: CONDITIONS.PROFIT },
    { label: LABELS.loss, id: uuidv4(), value: CONDITIONS.LOSS }
  ],
  onCondition: [
    { label: LABELS.greaterThan, id: uuidv4(), value: CONDITIONS.GREATER_THAN },
    {
      label: LABELS.greaterThanOrEqualTo,
      id: uuidv4(),
      value: CONDITIONS.GREATER_THAN_OR_EQUAL_TO
    },
    { label: LABELS.lowerThan, id: uuidv4(), value: CONDITIONS.LOWER_THAN },
    {
      label: LABELS.lowerThanOrEqualTo,
      id: uuidv4(),
      value: CONDITIONS.LOWER_THAN_OR_EQUAL_TO
    }
  ]
}

export const betConditionsOptions = {
  onType: [
    { label: LABELS.every, id: uuidv4(), value: CONDITIONS.EVERY },
    {
      label: LABELS.everyStreakOf,
      id: uuidv4(),
      value: CONDITIONS.EVERY_STREAK_OF
    },
    {
      label: LABELS.firstStreakOf,
      id: uuidv4(),
      value: CONDITIONS.FIRST_STREAK_OF
    },
    {
      label: LABELS.streakGreaterThan,
      id: uuidv4(),
      value: CONDITIONS.STREAK_GREATER_THAN
    },
    {
      label: LABELS.streakLowerThan,
      id: uuidv4(),
      value: CONDITIONS.STREAK_LOWER_THAN
    }
  ],
  onBetType: [
    { label: LABELS.bet, id: uuidv4(), value: CONDITIONS.BET },
    { label: LABELS.win, id: uuidv4(), value: CONDITIONS.WIN },
    { label: LABELS.lose, id: uuidv4(), value: CONDITIONS.LOSE }
  ],
  doType: [
    {
      label: LABELS.increaseByPercentage,
      id: uuidv4(),
      value: CONDITIONS.INCREASE_BY_PERCENTAGE
    },
    {
      label: LABELS.decreaseByPercentage,
      id: uuidv4(),
      value: CONDITIONS.DECREASE_BY_PERCENTAGE
    },
    {
      label: LABELS.increaseWinChanceBy,
      id: uuidv4(),
      value: CONDITIONS.INCREASE_WIN_CHANCE_BY
    },
    {
      label: LABELS.decreaseWinChanceBy,
      id: uuidv4(),
      value: CONDITIONS.DECREASE_WIN_CHANCE_BY
    },
    {
      label: LABELS.addToAmount,
      id: uuidv4(),
      value: CONDITIONS.ADD_TO_AMOUNT
    },
    {
      label: LABELS.subtractFromAmount,
      id: uuidv4(),
      value: CONDITIONS.SUBTRACT_FROM_AMOUNT
    },
    {
      label: LABELS.addToWinChance,
      id: uuidv4(),
      value: CONDITIONS.ADD_TO_WIN_CHANCE
    },
    {
      label: LABELS.subtractFromWinChance,
      id: uuidv4(),
      value: CONDITIONS.SUBTRACT_FROM_WIN_CHANCE
    },
    { label: LABELS.setAmount, id: uuidv4(), value: CONDITIONS.SET_AMOUNT },
    {
      label: LABELS.setWinChance,
      id: uuidv4(),
      value: CONDITIONS.SET_WIN_CHANCE
    },
    {
      label: LABELS.switchOverUnder,
      id: uuidv4(),
      value: CONDITIONS.SWITCH_OVER_UNDER
    },
    { label: LABELS.resetAmount, id: uuidv4(), value: CONDITIONS.RESET_AMOUNT },
    {
      label: LABELS.resetWinChance,
      id: uuidv4(),
      value: CONDITIONS.RESET_WIN_CHANCE
    },
    { label: LABELS.stop, id: uuidv4(), value: CONDITIONS.STOP }
  ]
}
export const BET_TYPE = {
  BETS_CONDITION: 'bets',
  PROFIT_CONDITION: 'profit'
}
export const restrictInput = [
  CONDITIONS.SWITCH_OVER_UNDER,
  CONDITIONS.RESET_AMOUNT,
  CONDITIONS.RESET_WIN_CHANCE,
  CONDITIONS.STOP
]

export const percentageInputs = [
  CONDITIONS.INCREASE_BY_PERCENTAGE,
  CONDITIONS.DECREASE_BY_PERCENTAGE,
  CONDITIONS.INCREASE_WIN_CHANCE_BY,
  CONDITIONS.DECREASE_WIN_CHANCE_BY,
  CONDITIONS.ADD_TO_WIN_CHANCE,
  CONDITIONS.SUBTRACT_FROM_WIN_CHANCE,
  CONDITIONS.SET_WIN_CHANCE
]
